import { FC } from 'react';

export const ShieldCheck: FC = () => (
  <svg
    viewBox="0 0 24 24"
    stroke="currentColor"
    fill='none'
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round">
    <path stroke="none" d="M0 0h24v24H0z" fill="none" />
    <path d="M12 3a12 12 0 0 0 8.5 3a12 12 0 0 1 -8.5 15a12 12 0 0 1 -8.5 -15a12 12 0 0 0 8.5 -3" />
    <path d="M9 12l2 2l4 -4" />
  </svg>
);

export default ShieldCheck;